import { cn } from '@repo/lib/cn';

import { PercentageHalfCircleChart } from '@/components/ui/chart';
import { PointIcon } from '@/components/ui/quiz';

interface QAttemptResultCardProps {
  /** Points earned, or null when the attempt was never marked. */
  score: number | null;
  /** Points the quiz is worth. */
  maxPoints: number;
  /**
   * Overrides the default full-width box, for callers that lay this out
   * alongside other content rather than on its own row.
   */
  className?: string;
}

/**
 * The score of one quiz attempt, as a percentage dial and a points count.
 *
 * Takes the two numbers rather than a quiz payload so it serves both the
 * student's quiz list and a parent looking at their child's attempts, which
 * arrive in different shapes.
 */
export default function QAttemptResultCard(qAttemptResultCardProps: QAttemptResultCardProps) {
  const { score, maxPoints, className } = qAttemptResultCardProps;
  const percentage: number = score != null && maxPoints > 0 ? (score / maxPoints) * 100 : NaN;
  return (
    <div className={cn('flex w-full shrink-0 items-center gap-2', className)}>
      {/* procenty */}
      <div className="space-y-0.5">
        <p className="text-muted-foreground text-xs">Wynik</p>
        <div className="flex items-center gap-1">
          <PercentageHalfCircleChart percentage={Number.isNaN(percentage) ? 0 : percentage} className="mx-0 size-6 max-w-6 shrink-0" strokeWidth={24} labelClassName="hidden" />
          <p className="text-accent-foreground text-xs font-medium">{Number.isNaN(percentage) ? '-' : percentage.toPrecision(3) + '%'}</p>
        </div>
      </div>
      {/* punkty */}
      <div className="space-y-0.5">
        <p className="text-muted-foreground text-xs">Punkty</p>
        <div className="flex items-center gap-1">
          <span className="flex size-6 items-center justify-center">
            <PointIcon className="size-5" />
          </span>
          <p className="text-accent-foreground text-xs font-medium">{score == null ? '-' : score}</p>
        </div>
      </div>
    </div>
  );
}
